import { connect } from "react-redux"
import PriceButtons from "../../components/shop/reservation/price-buttons.jsx"

const mapStateToProps = state => ({
  ...state.currentShop.reservation,
  selectedReservation: state.entities.reservations[state.currentShop.reservation.reservationId],
  players: state.entities.players
})

const mapDispatchToProps = dispatch => ({
  onChangeButtonsPosition: value => {
    dispatch({type: "CHANGE_SHOP_RESERVATION_BUTTONS_POSITION", payload: {value}})
    dispatch({type: "SAVE_USER_SETTINGS"})
  },
  onChangePrice: value => {
    dispatch({type: "SHOP_RESERVATION_PRICE_CHANGED", payload: {value}})
    dispatch({type: "SAVE_USER_SETTINGS"})
  },
  onChangePlayersNumber: (value, clickPosition) => {
    dispatch({type: "CHANGE_SHOP_RESERVATION_PLAYERS_NUMBER", payload: {value, clickPosition}})
    dispatch({type: "SAVE_USER_SETTINGS"})
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(PriceButtons)
